/* src/app/components/workspaces-info/workspaces-info.component.scss */
.ws-img {
  width: 4rem;
  height: 4rem;
  margin-right: 0.9375rem;
}
.ws-subtitle {
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 300;
  color: #72727f;
}
.ws-title {
  margin-top: 0.5rem;
  margin-bottom: 0;
  font-size: 1rem;
  line-height: 1.75rem;
  font-weight: 400;
  color: #2e2e38;
}
.ws-title img {
  display: inline-block;
  vertical-align: middle;
  width: 0.9375rem;
  height: 0.9375rem;
  margin-bottom: 0.125rem;
}
.workspace {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
  margin-bottom: 2rem;
  min-width: 16.875rem;
  text-decoration: none;
}
.ws-img-null {
  width: 4rem;
  height: 4rem;
}
/*# sourceMappingURL=workspaces-info.component.css.map */
